import { ResolutionType, useScreenStore } from "application/contexts/screen/ScreenStore";
import React, { FC } from "react";
import styles from "../../../offlineRecharge/OfflineRecharge.module.scss";

/** Indicador das 3 etapas: 1-Leitura, 2-Dados/Valor, 3-Gravação */
export interface StepIndicatorProps {
  /** Índice da etapa atual (0, 1 ou 2) */
  currentStepIndex: number;
}

export const StepIndicator: FC<StepIndicatorProps> = ({ currentStepIndex }) => {
  const { resolution } = useScreenStore();

  return (
    <div
      className={styles.stepContainer}
      style={{
        margin: resolution === ResolutionType.FULL_HD ? "36px 0" : "12px 0",
        fontSize: resolution === ResolutionType.FULL_HD ? 40 : 30,
      }}
    >
      {[0, 1, 2].map((i) => (
        <div
          key={i}
          style={{
            minWidth: resolution === ResolutionType.FULL_HD ? 120 : 100,
            height: resolution === ResolutionType.FULL_HD ? 80 : 60,
          }}
          className={currentStepIndex === i ? styles.selected : undefined}
        >
          {i + 1}
        </div>
      ))}
    </div>
  );
};
